// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10U8a","rootNoMargin":"styles_rootNoMargin__yx0e2"};